import Image from "next/image";
import Skeleton from "react-loading-skeleton";
import styles from "./ProductImage.module.css";

// Also need to list in remotePatterns in next.config.js
const supportedImageBaseUrls = [
  // IACM
  "https://d2q8km48t273sa.cloudfront.net/menu_photos",
  // // Deliverect
  // "https://resizer.staging.deliverect.com/",
  // "https://resizer.deliverect.com/",
  // Kounta - disabled for now due to costs, most images are from this
  // "https://cdn.kounta.com/core/images/",
  // "https://s3-ap-northeast-1.amazonaws.com/kounta/",
  // Zonal
  "https://izoneapps-cdn.zonalconnect.com/uploads/",
];

interface ProductImageProps {
  /** URL to image source. If not provided then a ProductImage will be null. */
  src?: string | null;
  alt: string;
  /**
   * The width of the resized image content (also used for height since always square)
   * Does not affect the width of the component which is always 100%
   * If the width will be dynamic specify the largest expected size here
   * NOTE: will download 2x the size of this value for retina screens
   */
  contentWidth: number;
  contentHeight?: number;
  /** Define the quality of the jpeg, 75 is default */
  quality?: number;
  skeleton?: boolean;
}

/**
 * Returns a next/image auto-resizable image for product photos from supported sources
 * and a regular img tag for other sources.
 */
export function ProductImage(props: ProductImageProps) {
  const { src, alt, contentWidth, contentHeight, quality, skeleton } = props;
  if (skeleton)
    return (
      <div className={styles.container}>
        <Skeleton width="100%" height="100%" />
      </div>
    );

  if (!src) return null;

  if (
    src.startsWith("https://images-dev.mytidyapp.com/") ||
    src.startsWith("https://images.mytidyapp.com/")
  ) {
    const srcUrl = new URL(src);
    srcUrl.searchParams.append("w", String(contentWidth));

    return (
      <div className={styles.container}>
        {/* eslint-disable-next-line @next/next/no-img-element -- Inside condition to exclude use of NextJS resizer */}
        <img
          src={srcUrl.toString()}
          alt={alt}
          loading="lazy"
          style={{ maxWidth: "100%", height: "auto" }} // Prevent layout issues
        />
      </div>
    );
  }

  if (!supportedImageBaseUrls.some((baseUrl) => src.startsWith(baseUrl))) {
    return (
      <div className={styles.container}>
        {/* eslint-disable-next-line @next/next/no-img-element -- Inside condition to exclude use of NextJS resizer */}
        <img src={src} alt={alt} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Image
        src={src}
        alt={alt}
        width={contentWidth}
        height={contentHeight ?? contentWidth}
        quality={quality}
      />
    </div>
  );
}
